export const environment = {
  serverUrl: 'https://uatdashboard.yashiacademy.com/',
  apiUrl: 'https://uatdashboard.yashiacademy.com/api/',
  productionDashboardUrl: 'https://dash.yashiacademy.com/dashboard',
  mcpUrl: 'https://mcpcdc.yashiacademy.com/',
  stage: 'uat',
  production: false,
  authUrl: 'https://auth.yashilabs.com/',
  wsUrl: 'wss://ws.yashiacademy.com/ws',
  realm: 'engineering_uat',
  client: 'engineering_quiz_dashboard',
  s3Bucket: 'yashi-labs',
  s3Object: 'engineering_quiz/files/',
  s3Url: 'https://yashi-labs.s3.ap-south-1.amazonaws.com/',
  desktopReleasePrefix: 'app-updates/yashi-academy/desktop/prod/',
  desktopReleaseBaseUrl: 'https://yashi-labs.s3.ap-south-1.amazonaws.com/',
  desktopReleaseNotesUrl: 'https://yashiacademy.com/release-notes/desktop',
};
